import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import PageMeta from "../../components/common/PageMeta";
import { useEffect, useState } from "react";
import Spinner from "../../components/ui/Spinner";
import {
    API_BASE_URL,
    API_URL,
    DEFAULT_PAGE_DESCRIPTION,
    DEFAULT_PAGE_TITLE,
    DEFAULT_PER_PAGE,
} from "../../utilities/constants";
import { NavLink, useLocation, useNavigate } from "react-router";
import Pagination from "../../components/ui/Pagination";
import useQueryParams from "../../hooks/useQueryParams";
import { handleApiCall, jsonToQueryParams } from "../../utilities/helper";
import { useUI } from "../../context/UI";
import ConfirmationModal from "../../components/ui/ConfirmationModal";
import CustomModal from "../../components/ui/CustomModal";
import TableFilter from "./TableFilter";

const MerchantPage = () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState(false);
    const navigate = useNavigate();
    const { updateQueryParam, queryParams } = useQueryParams();
    const pageNo = queryParams.get("pageNo") || 0;
    const pageSize = queryParams.get("pageSize") || DEFAULT_PER_PAGE;
    const sortOrder = queryParams.get("sortOrder") || "DESC";
    const location = useLocation();
    const {
        setSegmentTitle,
        addToastMessage,
        addNotification,
        setNewNotification
    } = useUI();
    const [controller, setController] = useState(null);

    const callListApi = async () => {
        controller?.abort();
        const newController = new AbortController();
        setController(newController);
        const { signal } = newController;
        setLoading(true);
        try {
            const query = jsonToQueryParams({
                keyword: queryParams.get("search") || "",
            });
            const response = await handleApiCall(
                `${API_BASE_URL}/api/1.0.0/partner?pageNo=${pageNo}&pageSize=${pageSize}&sortBy=createdAt&direction=${sortOrder}&${query}`,
                {
                    method: "GET"
                },
                null,
                signal
            );
            if (response.responseStatus == true) {
                setData(response.data);
                console.log(response.data);
            } else {
                setData(null);
            }
            if (response.responseCode !== 299) {
                setLoading(false);
            }
        } catch (e) {
            console.error("Error", e);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        callListApi();
        setSegmentTitle("User");
    }, [location.search]);

    const handleStatusChanges = async (id) => {
        try {
            const response = await handleApiCall(API_BASE_URL + `/api/1.0.0/agent/${id}/status/0`, {
                method: "PUT",
            });

            if (response.responseStatus === true) {
                addToastMessage({
                    status: true,
                    message:
                        "You have successfully deleted a agent, Thank You!",
                });
                callListApi();
                setNewNotification(true);
                addNotification({
                    id: Date.now(),
                    message: "You have successfully deleted a agent!",
                    status: true,
                    archive: false,
                });
            }
            else {
                addToastMessage({
                    status: false,
                    message: response?.responseDescription ||
                        `Something went wrong while deleting agent. Please try again.`,
                });
            }
        } catch (error) {
            addToastMessage({
                status: false,
                message: `Something went wrong while deleting agent. Please try again.`,
            });
        }
    };

    return (
        <>
            <PageMeta
                title={`Merchant - ${DEFAULT_PAGE_TITLE}`}
                description={`Merchant - ${DEFAULT_PAGE_DESCRIPTION}`}
            />

            <div className="flex justify-between items-center mb-1">
                <PageBreadcrumb pageTitle="Merchant" />
            </div>
            <div className="flex justify-between items-center mb-6">

                <TableFilter />
            </div>

            {loading ? (
                <div className="flex justify-center items-center">
                    <Spinner />
                </div>
            ) : (
                <div className="space-y-6">
                    <div className="relative overflow-x-auto sm:rounded-lg">
                        <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400 rounded-lg">
                            <thead className="text-xs text-gray-700 uppercase bg-gray-100 dark:bg-gray-700 dark:text-gray-400">
                                <tr>
                                    <th scope="col" className="px-6 py-3"> Name</th>
                                    <th scope="col" className="px-6 py-3"> Website Url</th>
                                    <th scope="col" className="px-6 py-3"> Description</th>
                                    <th scope="col" className="px-6 py-3"> Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data?.map((user, index) => (
                                    <tr key={index} className="border-b dark:border-gray-600 text-sm text-gray-700 dark:text-gray-300">
                                        <td className="px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white">
                                            <NavLink to={`/catalog`} state={{ user: user }}>
                                                <div className=" underline cursor-pointer flex items-center gap-2">
                                                    {user.photoSignedUrl ? (
                                                        <img
                                                            src={user.photoSignedUrl}
                                                            alt={user.stylistName || "Stylist"}
                                                            className="w-8 h-8 rounded-full object-fill"
                                                        />
                                                    ) : (
                                                        <div className="w-8 h-8 rounded-full bg-[rgb(222,206,172)] flex items-center justify-center text-sm font-semibold text-gray-700">
                                                            {user.name ? user.name.charAt(0).toUpperCase() : "-"}
                                                        </div>
                                                    )}
                                                    <span>{user.name || "-"}</span>
                                                </div>
                                            </NavLink>
                                        </td>
                                        <td className="px-6 py-4">
                                            {user.websiteUrl ? (
                                                <a
                                                    href={user.websiteUrl}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="text-yellow-700 hover:underline"
                                                >
                                                    {user.websiteUrl}
                                                </a>
                                            ) : (
                                                "-"
                                            )}
                                        </td>
                                        <td className="px-6 py-4">{user.description || "-"}</td>
                                        <td className="px-6 py-4">
                                            <CustomModal
                                                selector={
                                                    <label className="inline-flex items-center cursor-pointer">
                                                        <input
                                                            type="checkbox"
                                                            checked={user?.active}
                                                            readOnly
                                                            className="sr-only"
                                                        />
                                                        <div
                                                            className={`w-32 h-8 flex items-center justify-center rounded-full relative transition-colors duration-300 ${user?.active ? "bg-green-500" : "bg-gray-400"
                                                                }`}
                                                        >
                                                            <div
                                                                className={`absolute top-1 w-6 h-6 rounded-full bg-white shadow transition-all duration-300 ${user?.active ? "right-1" : "left-1"
                                                                    }`}
                                                            />
                                                            <span
                                                                className={`absolute w-full text-center text-xs font-medium transition-opacity duration-300 ${user?.active ? "opacity-100 text-white" : "opacity-0"
                                                                    }`}
                                                            >
                                                                Active
                                                            </span>
                                                            <span
                                                                className={`absolute w-full text-center text-xs font-medium transition-opacity duration-300 ${!user?.active ? "opacity-100 text-white" : "opacity-0"
                                                                    }`}
                                                            >
                                                                Inactive
                                                            </span>
                                                        </div>

                                                    </label>
                                                }
                                                content={
                                                    <ConfirmationModal
                                                        onConfirm={async () => {
                                                            await handleStatusChanges(user?.departmentId, !user?.active);
                                                            return true; // closes modal
                                                        }}
                                                        message={`Are you sure you want to ${user?.active ? "deactivate" : "activate"
                                                            } this ?`}
                                                    />
                                                }
                                            />
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </>
    );
};
export default MerchantPage;